import { UI, HStack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { FlatList } from 'native-base';
import React from 'react';

import { IBlockedAssetNormalized } from '../../../../../../store/customerDetail/types';
import { LoadingTable } from '../../../shared/LoadingTable';
import { EmptyList } from '../EmptyList';
import { ErrorListing } from '../ErrorListing';

import { emptyListProps, tableHead } from './constants';

import { BlockedTypes } from '.';

interface ItemProps {
  item: IBlockedAssetNormalized;
}

export const ItemValueMobile: React.FC<{ value: string; label: string }> = ({ value, label }) => {
  return (
    <VStack py="stack.nano" space="stack.quarck" maxW="75%">
      <UI.Text variant="semibold" fontSize="md">
        {label}
      </UI.Text>
      <UI.Text fontSize="md">{value}</UI.Text>
    </VStack>
  );
};

export const ItemMobile: React.FC<ItemProps> = ({ item }) => {
  return (
    <UI.Shadow level={1} p="inset.xs" my="stack.nano" borderRadius="sm">
      <HStack justifyContent="space-between">
        <ItemValueMobile label={tableHead.description} value={item.description} />
        <ItemValueMobile label={tableHead.value} value={Utils.Mask.Money(item.value)} />
      </HStack>
    </UI.Shadow>
  );
};

export const BlockedMobile: React.FC<BlockedTypes.Props> = ({
  error,
  isLoading,
  blockedAssets,
  onRefresh,
}) => {
  const renderTable = () => {
    if (error) {
      return <ErrorListing handleReload={onRefresh} />;
    }
    if (blockedAssets.length === 0 && !isLoading) {
      return <EmptyList {...emptyListProps} />;
    }
    return (
      <UI.Table testId="table-customers-ties" isLoading={false} cols={3} rows={5}>
        {isLoading ? (
          <LoadingTable items={3} isMobile />
        ) : (
          <FlatList
            windowSize={20}
            maxToRenderPerBatch={20}
            updateCellsBatchingPeriod={5}
            data={blockedAssets}
            showsVerticalScrollIndicator={false}
            onEndReachedThreshold={1.5}
            renderItem={({ item }) => <ItemMobile item={item} />}
          />
        )}
      </UI.Table>
    );
  };

  return (
    <UI.Shadow
      level={1}
      borderRadius="sm"
      my="inset.sm"
      paddingX="inline.xxxs"
      paddingY="inline.xxs"
      pb={0}>
      {renderTable()}
    </UI.Shadow>
  );
};
